module.exports = __webpack_public_path__ + "img/IMG_2131.b88e6d81.jpg";